import { API_CALL } from 'actions/actionConstants'
import { AppAction } from 'actions/types/ActionTypes'
import { FETCH_MERCHANDISE_CATEGORIES_LIST } from 'actions/apiActionConstants'
import getObjectKey from 'lib/object/getObjectKey'
import getMerchandiseCategoriesList from 'api/merchandise/getMerchandiseCategoriesList'

function fetchMerchandiseCategoriesList(filters: App.MerchandiseCategoryFilters): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const key = getObjectKey(filters)
    if (state.merchandise.merchandiseCategoryLists[key] ||
      state.merchandise.fetchingMerchandiseCategoryLists[key] ||
      state.merchandise.merchandiseCategoryListErrors[key]
    ) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_MERCHANDISE_CATEGORIES_LIST,
      request: () => getMerchandiseCategoriesList(filters),
      key,
    })
  }
}

export default fetchMerchandiseCategoriesList
